import * as React from "react";

export default function UserBar({ email, onSignOut, compact = false, emailOnly = false }) {
  if (emailOnly) {
    return <p className="truncate text-[10px] text-slate-300">{email}</p>;
  }

  if (compact) {
    return (
      <div className="flex min-w-0 items-center gap-2">
        <p className="truncate text-xs text-slate-300">{email}</p>
        <button
          type="button"
          onClick={onSignOut}
          className="shrink-0 text-[11px] font-medium text-sky-200 underline decoration-sky-400/40 underline-offset-2 hover:text-white"
        >
          Sign out
        </button>
      </div>
    );
  }

  return (
    <div className="flex items-center justify-between gap-3 rounded-xl border border-white/10 bg-white/10 px-3 py-2 text-sm text-slate-100">
      <div className="min-w-0">
        <p className="text-[11px] uppercase tracking-wide text-slate-300">Signed in as</p>
        <p className="truncate font-medium text-white">{email}</p>
      </div>
      <button
        type="button"
        onClick={onSignOut}
        className="shrink-0 rounded-lg border border-white/15 bg-white/10 px-2.5 py-1 text-xs font-medium text-white transition hover:bg-white/20"
      >
        Sign out
      </button>
    </div>
  );
}
